// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Lnnm","rootMobile":"styles_rootMobile__1MGBr"};